import { useCallback, useEffect, useState } from 'react'

import { websocketActionsWorkspaces } from '@/common/context/websocketActions/constants'
import useWebsocketAction from '@/common/hooks/useWebsocketAction/useWebsocketAction'
import useWebsocketActions from '@/common/hooks/useWebsocketActions/useWebsocketActions'

import { loadingByWebsocketActionType } from './constants'

const useWebsocketTransactionAction = ({ fetchData, fetchTimeline }) => {
  const { pendingWebsocketAction, clearPendingWebsocketAction } = useWebsocketActions(
    websocketActionsWorkspaces.transactions
  )
  const [activeAction, setActiveAction] = useState(null)

  const onComplete = useCallback(() => {
    fetchData()
    fetchTimeline()
    setActiveAction(null)
  }, [fetchData, fetchTimeline])

  useEffect(() => {
    if (!pendingWebsocketAction) return

    if (pendingWebsocketAction.websocketUrl) {
      setActiveAction(pendingWebsocketAction)
    } else {
      onComplete()
    }

    clearPendingWebsocketAction()
  }, [pendingWebsocketAction, clearPendingWebsocketAction, onComplete])

  const { isInProgress } = useWebsocketAction({
    websocketUrl: activeAction?.websocketUrl,
    onComplete,
    onError: onComplete,
  })

  const loadingMap = isInProgress ? loadingByWebsocketActionType[activeAction?.type] : null

  return {
    isSummaryCardLoading: Boolean(loadingMap?.summaryCard),
    isDetailCardLoading: Boolean(loadingMap?.detailCard),
    isShippingDetailsCardLoading: Boolean(loadingMap?.shippingDetailsCard),
    isDocumentsCardLoading: Boolean(loadingMap?.documentsCard),
    isLineItemsToReturnCardLoading: Boolean(loadingMap?.lineItemsToReturnCard),
    isFullPageLoading: Boolean(loadingMap?.fullPage),
  }
}

export default useWebsocketTransactionAction
